import type { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    image: {
      backgroundColor: theme.palette.secondary.main,
      width: '100%',
      height: '200px'
    }
  });

export default styles;
